import { Stack, Text } from '@chakra-ui/react';
import { PlanProps } from '@/components/PricingPlan/types';
import React from 'react';

const FreePlanCover: React.FC<PlanProps> = ({ t }) => {
  return (
    <Stack align="center" h="100px" justify="center">
      <Text color="blue.500" fontSize="4xl" fontWeight="bold">
        {t('free')}
      </Text>
    </Stack>
  );
};

export default FreePlanCover;
